import { BreadcrumbListSchemaOrg } from './schemaOrg/BreadcrumbList';
import { Schema, SchemaGetter } from 'effect';

// 1. Internal domain type (what components use)
export const BreadcrumbItem = Schema.Struct({
  name: Schema.String,
  url: Schema.optional(Schema.String),
}).annotate({ identifier: 'BreadcrumbItem' });

// 4. Transform from JSON-LD format to internal array
// decodeTo(To, SchemaTransformation.transform): decode: From -> To, encode: To -> From
// We want encode to produce JSON-LD, so JSON-LD is the "From" (encoded) side
export const BreadcrumbListFromItems = BreadcrumbListSchemaOrg.pipe(
  Schema.decodeTo(Schema.Array(BreadcrumbItem), {
    decode: SchemaGetter.transform((jsonLd) =>
      jsonLd.itemListElement.map((item) => ({
        name: item.name,
        url: item.item,
      }))
    ),
    encode: SchemaGetter.transform((items) => ({
      '@context': 'https://schema.org' as const,
      '@type': 'BreadcrumbList' as const,
      itemListElement: items.map((item, index) => ({
        '@type': 'ListItem' as const,
        position: index + 1,
        name: item.name,
        ...(item.url !== undefined ? { item: item.url } : {}),
      })),
    })),
  })
);

// 5. Schema that outputs JSON string directly
export const BreadcrumbListJsonLdString = Schema.fromJsonString(BreadcrumbListFromItems);

// 6. Utility function for encoding
export const encodeBreadcrumbListToJsonLdString = Schema.encodeSync(BreadcrumbListJsonLdString);
